import { render, staticRenderFns } from "./CreateUpdateRoute.vue?vue&type=template&id=9bbe5c8e&"
import script from "./CreateUpdateRoute.vue?vue&type=script&lang=js&"
export * from "./CreateUpdateRoute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports